import { Card } from '@mui/material';
import { styled } from '@mui/material/styles';

export type BlurSizes = 'sm' | 'md' | 'lg' | 'xl';

export type BlurColors = 'light' | 'dark';

export type BlurType = {
  size: BlurSizes;
  color: BlurColors;
};

const blurSizeMapping: Record<BlurSizes, string> = {
  sm: '4px',
  md: '8px',
  lg: '12px',
  xl: '20px',
};

interface BlurredCardProps {
  blur: BlurType;
}

export const StyledCard = styled(Card)(({ theme: { palette, spacing } }) => ({
  borderColor: palette.primary[100],
  borderRadius: spacing(3),
}));

export const BlurredCard = styled(StyledCard)<BlurredCardProps>(({ blur }) => ({
  backgroundColor:
    blur.color === 'light'
      ? 'rgba(255, 255, 255, 0.6)'
      : 'rgba(52, 64, 84, 0.6)',
  backdropFilter: `blur(${blurSizeMapping[blur.size]})`,
}));
